import { render, staticRenderFns } from "./promotion-table.vue?vue&type=template&id=2e0b3021&scoped=true&"
import script from "./promotion-table.ts?vue&type=script&lang=ts&"
export * from "./promotion-table.ts?vue&type=script&lang=ts&"
import style0 from "./promotion-table.vue?vue&type=style&index=0&id=2e0b3021&prod&lang=scss&"
import style1 from "./promotion-table.vue?vue&type=style&index=1&id=2e0b3021&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0b3021",
  null
  
)

export default component.exports